import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-cycle",
  "use": "foquz-icon-cycle-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-cycle\"><path d=\"M11 1v3H8m.983 6.044a5 5 0 111.423-6.377m-.518 3.415a1.5 1.5 0 11-.776 2.897 1.5 1.5 0 01.776-2.897z\" stroke=\"#73808D\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol